import React, { FC } from "react";
import { Link, animateScroll as scroll } from "react-scroll";
import { StaticImage } from "gatsby-plugin-image";

interface SidebarProps {
  open: boolean;
}
const Sidebar: FC<SidebarProps> = ({ open }) => {
  return (
    <div
      className={`group md:transition-width duration-300 ease-in w-32 hover:w-64 transform transition-all h-full bg-primary fixed ${
        open ? "-left-0" : "-left-32"
      } top-0 md:left-0 flex flex-col items-center justify-between z-50`}
    >
      <div className="w-full h-1/6 bg-primary flex items-center justify-center text-center text-4xl text-white font-custom border-b border-gray-100">
        UT
      </div>
      <ul className="w-full h-2/6 flex flex-col items-start justify-evenly pl-12">
        <li className="my-3 pb-3 cursor-pointer">
          <Link
            activeClass="active"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            to="home"
            className="flex items-center justify-evenly"
          >
            <StaticImage
              src="../images/sidebar/home.png"
              alt="Home"
              layout="constrained"
              placeholder="blurred"
              className="w-6 h-6 mr-3 object-contain"
            />
            <h3 className="invisible text-base text-white font-custom transition duration-150 font-light group-hover:visible">
              Home
            </h3>
          </Link>
        </li>
        <li className="my-3 pb-3 cursor-pointer">
          <Link
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            to="about"
            className=" flex items-center justify-evenly"
          >
            <StaticImage
              src="../images/sidebar/about.png"
              alt="Home"
              layout="constrained"
              placeholder="blurred"
              className="w-6 h-6 mr-3 object-contain"
            />
            <h3 className="invisible text-base text-white font-custom transition duration-150 font-light group-hover:visible">
              About
            </h3>
          </Link>
        </li>
        <li className="my-3 pb-3 cursor-pointer">
          <Link
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            to="toolkit"
            className=" flex items-center justify-evenly"
          >
            <StaticImage
              src="../images/sidebar/toolkit.png"
              alt="Home"
              layout="constrained"
              placeholder="blurred"
              className="w-6 h-6 mr-3 object-contain"
            />
            <h3 className="invisible text-base text-white font-custom transition duration-150 font-light group-hover:visible">
              Toolkit
            </h3>
          </Link>
        </li>
        <li className="my-3 pb-3 cursor-pointer">
          <Link
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            to="projects"
            className=" flex items-center justify-evenly"
          >
            <StaticImage
              src="../images/sidebar/projects.png"
              alt="Home"
              layout="constrained"
              placeholder="blurred"
              className="w-6 h-6 mr-3 object-contain"
            />
            <h3 className="invisible text-base text-white font-custom transition duration-150 font-light group-hover:visible">
              Projects
            </h3>
          </Link>
        </li>
        <li className="my-3 pb-3 cursor-pointer">
          <Link
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            to="testimonial"
            className=" flex items-center justify-evenly"
          >
            <StaticImage
              src="../images/sidebar/testimonial.png"
              alt="Home"
              layout="constrained"
              placeholder="blurred"
              className="w-6 h-6 mr-3 object-contain"
            />
            <h3 className="invisible text-base text-white font-custom transition duration-150 font-light group-hover:visible">
              Testimonials
            </h3>
          </Link>
        </li>
        <li className="my-3 pb-3 cursor-pointer">
          <Link
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            to="contact"
            className=" flex items-center justify-evenly"
          >
            <StaticImage
              src="../images/sidebar/contact.png"
              alt="Home"
              layout="constrained"
              placeholder="blurred"
              className="w-6 h-6 mr-3 object-contain"
            />
            <h3 className="invisible text-base text-white font-custom transition duration-150 font-light group-hover:visible">
              Contact
            </h3>
          </Link>
        </li>
      </ul>
      <div className="w-full h-20 pl-11 flex flex-col items-start justify-center">
        <Link
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
          to="home"
          className="my-3 flex items-center justify-center cursor-pointer"
        >
          <StaticImage
            src="../images/down.png"
            alt="Home"
            layout="constrained"
            placeholder="blurred"
            className="w-8 h-16 mr-3 object-cover transform rotate-180"
          />
          <h3 className="invisible text-base text-white font-custom font-light block group-hover:visible">
            Back to top
          </h3>
        </Link>
      </div>
    </div>
  );
};

export default Sidebar;
